import React from 'react';
import { useParams } from 'react-router-dom';

import { SpinnerOverlay } from '@components/common';
import ProjectProfile from '@components/routes/AdminPanel/ProjectProfile';

import { useQueryPortalProject } from '@hooks/portal/projects/portalProjects/useQueryPortalProject';
import { useQueryUser } from '@hooks/useQueryUser';

const ProjectProfileHOC = () => {
	const { id = '' } = useParams();

	const { portalProject, isLoadingPortalProject } = useQueryPortalProject(id);

	const { organisationId } = useQueryUser();

	return (
		<>
			{isLoadingPortalProject && <SpinnerOverlay />}
			{portalProject
				&& <ProjectProfile
					organisationId={organisationId}
					project={portalProject}
				/>
			}
		</>
	);
};

export default ProjectProfileHOC;
